module.exports = __webpack_public_path__ + "static/media/icn_ui_arrow_left.5e9b1612.svg";